// extracted by mini-css-extract-plugin
export var layout = "legal-module--layout--3OEKW";
export var menu = "legal-module--menu--1mBon";
export var legalOverrides = "legal-module--legal-overrides--2AXSX";
export var faqs = "legal-module--faqs--2X6Ib";
export var mainH1 = "legal-module--main-h1--3CJUp";
export var sticky = "legal-module--sticky--1K5A2";